import { IOMConfig } from '@models/Log';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import AdminLogApi from 'apis/api/AdminLog';
import AuthServiceApi from 'apis/api/Auth';

export const getAllOMConfig = createAsyncThunk('adminConfig/getAllOMConfig', async () => {
  const response = await AdminLogApi.GetAllConfig();
  return response.data;
});

export const getAllUser = createAsyncThunk('adminConfig/getAllUser', async () => {
  const response = await AuthServiceApi.GetAllUserV2();
  return response.data;
});

export const getAllUserOperating = createAsyncThunk('adminConfig/GetListUserByRoleV2', async (roleName: any) => {
  const response = await AuthServiceApi.GetListUserByRoleV2(roleName);
  return response.data;
});

export const getAllUserSales = createAsyncThunk('adminConfig/getAllUserSales', async () => {
  const response = await AuthServiceApi.GetAllUserSales();
  return response.data;
});

export const getAllUserAccountant = createAsyncThunk('adminConfig/GetListAccountantByRoleV2', async (roleName: any) => {
  const response = await AuthServiceApi.GetListUserByRoleV2(roleName);
  return response.data;
});

interface ISelectLoadedData {
  OMConfigLoaded?: boolean | null;
  AllUserLoaded?: boolean | null;
  AllUserOperatingLoaded?: boolean | null;
  AllUserSalesLoaded?: boolean | null;
  AllUserAccountantsLoaded?: boolean | null;
}

type initialStateType ={
  loadedData: ISelectLoadedData;
  configOM: Array<IOMConfig>;
  allUser: any[];
  allUserOperating: any[];
  allUserAccountant: any[];
  allUserSales: any[];
};
const initialState: initialStateType = {
  configOM: [],
  allUser: [],
  allUserOperating: [],
  allUserAccountant: [],
  allUserSales: [],
  loadedData: {
    OMConfigLoaded: null,
    AllUserLoaded: null,
    AllUserOperatingLoaded: null,
    AllUserSalesLoaded: null,
    AllUserAccountantsLoaded: null
  }
}
const adminConfig = createSlice({
  name: 'adminConfig',
  initialState: initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getAllOMConfig.fulfilled, (state, action) => {
      console.log('addCase getAllOMConfig', action.payload?.data);
      state.loadedData.OMConfigLoaded = true; // đã load chi nhánh đầu
      state.configOM = action.payload?.data || [];
    });
    builder.addCase(getAllUser.fulfilled, (state, action) => {
      console.log('addCase getAllUser', action.payload?.data);
      state.loadedData.AllUserLoaded = true; // đã load chi nhánh đầu
      state.allUser = action.payload?.data || [];
    });
    builder.addCase(getAllUserOperating.fulfilled, (state, action) => {
      console.log('addCase getAllUserOperating', action.payload?.data);
      state.loadedData.AllUserOperatingLoaded = true; // đã load chi nhánh đầu
      state.allUserOperating = action.payload?.data || [];
    });

    builder.addCase(getAllUserSales.fulfilled, (state, action) => {
      console.log('addCase getAllUserSales', action.payload?.data);
      state.loadedData.AllUserSalesLoaded = true; // đã load chi nhánh đầu
      state.allUserSales = action.payload?.data || [];
    });

    builder.addCase(getAllUserAccountant.fulfilled, (state, action) => {
      console.log('addCase getAllUserAccountant', action.payload?.data);
      state.loadedData.AllUserAccountantsLoaded = true; // đã load chi nhánh đầu
      state.allUserAccountant = action.payload?.data || [];
    });
  },
});

export default adminConfig.reducer;